<div class="uomrecorddetail-container">
  <miq-record-input
    class="uomrecorddetail-inputone"
    [ngClass]="{ 'editreport-inputone': module === 'reports' }"
    [recordDetail]="recordDetail"
    [isNewRecord]="isNewRecord"
    [isDisabled]="isDisabled"
    [record]="record"
    [isRecordDetail]="isRecordDetail"
    (rdChange)="validateAndEmitInput($event)"
  ></miq-record-input>
  <miq-record-input
    class="uomrecorddetail-inputtwo"
    [ngClass]="{ 'editreport-inputtwo': module === 'reports' }"
    [recordDetail]="recordDetail.unit"
    [isNewRecord]="isNewRecord"
    [isDisabled]="isDisabled"
    [record]="record"
    [isRecordDetail]="isRecordDetail"
    (rdChange)="validateAndEmitUom()"
  ></miq-record-input>
</div>
